import React, { PropsWithChildren } from 'react';
import { useEnv } from './core/useEnv';

export const EnvWrapper = ({children}: PropsWithChildren<{}>): JSX.Element => {
    console.log('EnvWrapper: checking if environment is initialized...');
    const {initialized} = useEnv();

    return (
        <>
            {initialized && children}
        </>
    )
};

